// import { HubClient } from './HubClient';

// import HubClient from './HubClient';
export * from './Utils';
export * from './HubClient';

// export const SignalRHubClient = HubClient;
